export const BASE_API = process.env.REACT_APP_Pos_APP_API_URL;
export const BASE_API_SIGN = BASE_API +"/api-sign";
export const BASE_API_POS = BASE_API + "/api-pos";
export const BASE_API_MASTER = BASE_API + "/api-master";

export const BASE_SSO = process.env.REACT_APP_SSO_URL;
export const BASE_API_SIGN_LOCAL = process.env.REACT_APP_Signal_APP_API_URL;
